import React from 'react';
const Plans = () => {
  return <section id="planes" className="py-16 bg-white" data-id="element-154">
      <div className="container mx-auto px-4" data-id="element-155">
        <div className="text-center mb-16" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-157">
            ¡Elige tu Plan!
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-158">
            Selecciona el plan que mejor se adapte a tus necesidades
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-159">
          <div className="w-full max-w-5xl mb-10" data-id="element-160">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ufwx5gF1eLzD2Koi14gnyg/PLANES_SUSCRIPCION.png" alt="Planes de suscripción Guaterflow" className="w-full h-auto rounded-xl shadow-lg" data-id="element-161" />
          </div>
          <button className="bg-[#2d98e2] hover:bg-[#146ead] text-white font-medium py-4 px-8 rounded-lg transition-colors text-lg" data-id="element-162">
            ¡Suscríbete Aquí!
          </button>
        </div>
      </div>
    </section>;
};
export default Plans;